(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusAssessControllers')
        .controller('RecomUpdateStatusAssessByActionPlanAssessmentController', Controller);

    Controller.$inject = ['$rootScope', '$scope', '$state', '$stateParams', '$mdToast', 'recomActionPlanUpdateStatusService'];

    function Controller($rootScope, $scope, $state, $stateParams, $mdToast, recomActionPlanUpdateStatusService) {
        $scope.readOnly = isReadOnly();
        $scope.date = new Date();

        $scope.completionStatuses = [];
        recomActionPlanUpdateStatusService
            .getActionPlanUpdateStatusLookups()
            .then(function (containerPlanLookups) {
                $scope.completionStatuses = containerPlanLookups.CompletionStatuses;
            });

        if ($scope.actionPlanAssessment.ComputedTargetDate) $scope.actionPlanAssessment.ComputedTargetDate = moment($scope.actionPlanAssessment.ComputedTargetDate).format();
        if ($scope.actionPlanAssessment.AssessmentTargetDate) $scope.actionPlanAssessment.AssessmentTargetDate = moment($scope.actionPlanAssessment.AssessmentTargetDate).format();

        // Show Completion Status?
        $scope.showCompletionStatus = function (completionStatus) {
            if (_.isUndefined($scope.actionPlanAssessment.AssessmentCompletionStatusID)) return true;

            return completionStatus.LookupAttributeValueID === $scope.actionPlanAssessment.AssessmentCompletionStatusID;
        };

        // Select Completion Status
        $scope.selectCompletionStatus = function (completionStatus) {
            if ($scope.readOnly) return;

            $scope.pageIsDirty();

            if ($scope.isCompletionStatusSelected()) {
                $scope.actionPlanAssessment.AssessmentCompletionStatusID = undefined;
                $scope.actionPlanAssessment.AssessmentCompletionDate = undefined;
                return;
            }

            $scope.actionPlanAssessment.AssessmentCompletionStatusID = completionStatus.LookupAttributeValueID;

            if ($scope.isFieldRequired('AssessmentTargetDate') && _.isUndefined($scope.actionPlanAssessment.AssessmentTargetDate)) {
                $scope.actionPlanAssessment.AssessmentTargetDate = $scope.actionPlanAssessment.AssessmentComputedTargetDate;
            }
        };

        $scope.isCompletionStatusSelected = function () {
            return !_.isUndefined($scope.actionPlanAssessment.AssessmentCompletionStatusID);
        };

        $scope.enableByForceTargetDate = function () {
            if ($scope.readOnly) return false;
            return $scope.actionPlanAssessment.AssessmentTargetDate < $scope.date;
        };

        // Show Reset Action?
        $scope.showResetAction = function () {
            if ($scope.readOnly) return false;

            return $scope.ctrlCtxt.needSaveChanges;
        };

        // Show Submit Action?
        $scope.showSubmitAction = function () {
            if ($scope.readOnly) return false;

            return $scope.isCompletionStatusSelected();
        };

        // Page is dirty
        $scope.ctrlCtxt.needSaveChanges = false;
        $scope.ctrlCtxt.isLoading = false;

        $scope.pageIsDirty = function () {
            $scope.ctrlCtxt.needSaveChanges = true;
            $rootScope.$broadcast('page-is-dirty');
        };

        $scope.pageIsNotDirty = function () {
            $scope.ctrlCtxt.needSaveChanges = false;
            $rootScope.$broadcast('page-is-not-dirty');
        };

        // Reset forms
        $scope.reset = function () {
            if ($scope.readOnly) return;
            $state.reload();
        };

        // Is Assess And Continue Disabled?
        $scope.isAssessAndContinueDisabled = function (form) {
            if ($scope.readOnly) return true;
            if (!$scope.isCompletionStatusSelected()) return true;

            return form.$invalid;
        };

        // Is Field Required?
        $scope.isFieldRequired = function (fieldName) {
            if (_.isUndefined(fieldName)) return false;
            if (_.isUndefined($scope.actionPlanAssessment.AssessmentFieldConditions_ByCompletionStatusID)) return false;

            var conditionsByCompStatusID = $scope.actionPlanAssessment.AssessmentFieldConditions_ByCompletionStatusID;

            var compStatusID = $scope.actionPlanAssessment.AssessmentCompletionStatusID;
            if (_.isNumber(compStatusID)) compStatusID = compStatusID.toString();

            var fieldConditions = conditionsByCompStatusID[compStatusID][fieldName];

            if (_.isUndefined(fieldConditions)) return false;

            return fieldConditions['required'];
        };

        // Assess and Continue
        $scope.assessAndContinue = function (form) {
            if ($scope.readOnly) return;

            if ($scope.isAssessAndContinueDisabled(form)) {
                $scope.ctrlCtxt.showSubmitError = true;
                return;
            };
            if ($scope.enableByForceTargetDate()) {
                $scope.ctrlCtxt.showSubmitError = true;
                return true;
            }

            $scope.ctrlCtxt.showSubmitError = false;

            $scope.ctrlCtxt.isLoading = true;

            recomActionPlanUpdateStatusService
                .assessActionPlan($stateParams.ItemPersonID, $scope.actionPlan.ActionPlanID, $scope.actionPlanAssessment)
                .then(function (updatedActionPlanAssessment) {
                    $scope.pageIsNotDirty();

                    $mdToast.show(
                        $mdToast
                            .simple()
                            .content('Action plan has been assessed')
                            .position('top right')
                            .hideDelay($scope.govNotificationDelay)
                            .action('OK')
                            .theme('primary')
                    );

                    $scope.actionPlanAssessment = updatedActionPlanAssessment;
                    $scope.readOnly = isReadOnly();

                    var initIdx = _.findIndex($scope.actionPlanStatusList, {
                        ActionPlan: { ActionPlanID: $scope.actionPlan.ActionPlanID }
                    });
                    $scope.actionPlanStatusList[initIdx].ActionPlanAssessment = updatedActionPlanAssessment;

                    var haveAllActionPlansBeenAssessed = _.every($scope.actionPlanStatusList, {
                        ActionPlanAssessment: { IsLocked: true }
                    });

                    if (haveAllActionPlansBeenAssessed) {
                        $state.go('recomActionPlanUpdateStatusAssess.actionPlans.completed');
                        return;
                    }

                    initIdx += 1;
                    if (initIdx === $scope.actionPlanStatusList.length) initIdx = 0;

                    $state.go('recomActionPlanUpdateStatusAssess.actionPlans.byActionPlanCriterias', {
                        ActionPlanID: $scope.actionPlanStatusList[initIdx].ActionPlan.ActionPlanID
                    });
                })
                .finally(function () {
                    $scope.ctrlCtxt.isLoading = false;
                });
        };

        // Go to Criterias
        $scope.goToCriterias = function () {
            if (!$scope.aPlanAssessmentSummary.UseByQuarterPaging) {
                $state.go('recomActionPlanUpdateStatusAssess.actionPlans.byActionPlanCriterias', {
                    ActionPlanID: $scope.actionPlan.ActionPlanID
                }, {
                    reload: true
                });

                return;
            }

            var lastFiscalYearQuarterKey = _.last($scope.ctrlCtxt.fiscalYearQuarterKeys);

            if (!lastFiscalYearQuarterKey) {

                // Will handle no criterias in the future
                $state.go('recomActionPlanUpdateStatusAssess.actionPlans.byActionPlanCriterias', {
                    ActionPlanID: $scope.actionPlanAssessment.ActionPlanID,
                });

                return;
            }

            $state.go('recomActionPlanUpdateStatusAssess.actionPlans.byActionPlanCriteriasByQuarter', {
                ActionPlanID: $scope.actionPlanAssessment.ActionPlanID,
                FiscalYearQuarterKey: lastFiscalYearQuarterKey
            });
        };


        // Helpers
        function isReadOnly() {
            if (!$scope.actionPlan) return true;

            return $scope.actionPlanAssessment.IsLocked;
        }

    }
})();